import { useState } from "react";
import { Play } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import JsonLd from "@/components/JsonLd";
import { videoSection } from "@/i18n/seoPages";

const SITE = "https://reflectumpellicule.com";
const EMBED_URL = "https://www.youtube-nocookie.com/embed/2jIPWBCLhBc";

// Lecteur YouTube Short vertical (9:16), chargé UNIQUEMENT au clic.
export default function VideoPlayer({ testId = "video", withJsonLd = false, className = "" }) {
  const { lang } = useLanguage();
  const v = videoSection[lang];
  const [playing, setPlaying] = useState(false);

  const videoLd = {
    "@context": "https://schema.org", "@type": "VideoObject",
    name: v.videoName,
    description: v.summary,
    thumbnailUrl: `${SITE}/images/video-poster.webp`,
    embedUrl: EMBED_URL,
    contentUrl: "https://youtube.com/shorts/2jIPWBCLhBc",
    duration: "PT1M6S",
    inLanguage: "fr",
    isFamilyFriendly: true,
    author: { "@type": "Organization", name: "Reflectum Pellicule", url: SITE },
  };

  return (
    <div
      className={`relative aspect-[9/16] rounded-2xl overflow-hidden bg-slate-900 shadow-[0_24px_60px_rgba(0,0,0,0.18)] ${className}`}
      data-testid={`${testId}-frame`}
    >
      {withJsonLd && <JsonLd id={`video-${testId}`} data={videoLd} />}
      {playing ? (
        <iframe
          src={`${EMBED_URL}?autoplay=1&rel=0`}
          title={v.iframeTitle}
          data-testid={`${testId}-iframe`}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
          className="absolute inset-0 w-full h-full border-0"
        />
      ) : (
        <button
          type="button"
          onClick={() => setPlaying(true)}
          data-testid={`${testId}-play`}
          aria-label={v.playLabel}
          className="group absolute inset-0 w-full h-full cursor-pointer"
        >
          <img
            src="/images/video-poster.webp"
            alt={v.posterAlt}
            width={1080}
            height={1920}
            loading="lazy"
            decoding="async"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <span className="absolute inset-0 bg-slate-950/25 transition-colors group-hover:bg-slate-950/40" />
          <span className="absolute inset-0 grid place-items-center">
            <span className="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-blue-600 text-white grid place-items-center shadow-xl shadow-black/30 transition-transform duration-300 group-hover:scale-110">
              <Play className="w-7 h-7 sm:w-8 sm:h-8 ml-1 fill-current" />
            </span>
          </span>
        </button>
      )}
    </div>
  );
}
